import React, { Component } from 'react';

import classes from './Tabs.module.css';
import config from '../../../constants/config';
import BadgeDot from '../BadgeDot/BadgeDot';

export default class Tabs extends Component {
  _onTabClick = (tab) => {
    this.props.onTabClick(tab);
  }

  _renderTabNavButton = (text, idx, arr) => {
    const { activeTab } = this.props;
    let tabNavStyle;
    if (this.props.squared) {
      tabNavStyle = [classes.TabsNavButtonSquared, (activeTab === idx ? classes.TabsNavSquaredSelected : '')].join(' ');
    } else {
      tabNavStyle = [classes.TabsNavButton, (activeTab === idx ? classes.TabNavSelected : '')].join(' ');
    }

    return (
      <nav onClick={this._onTabClick.bind(this, idx)} key={idx} className={tabNavStyle} style={{ minWidth: arr.length > 2 ? '33%' : '49%' }}>
        <span className={classes.TabText}>{text}</span>
        <span className={classes.TabsNavDot}><BadgeDot small active={this.props.dots && this.props.dots[idx] && !this.props.squared} /></span>
      </nav>
    );
  }
  _renderTabsNav = () => {
    let tabNavStyles = config.IS_LANDSCAPE ? {...this.props.tabsNavStyle, maxWidth: this.props.squared ? '100%' : config.CENTER_WRAPPER_CONTENT_WIDTH} : this.props.tabsNavStyle;
    return (
      <div className={classes.TabsNavWrapper} style={this.props.tabsNavWrapperStyle}>
        <nav className={this.props.squared ? classes.TabsNavSquared : classes.TabsNav} style={tabNavStyles}>
          {this.props.tabNavTitles.map(this._renderTabNavButton)}
        </nav>
      </div>
    );
  }
  _renderTabsBody = () => {
    const { activeTab } = this.props;
    return (
      <div className={classes.TabsBody}>
        <div className={classes.Tabs}>
          {this.props.components[activeTab]}
        </div>
      </div>
    );
  }

  render () {
    return (
      <div className={classes.TabsWrapper}>
        {this._renderTabsNav()}
        {this._renderTabsBody()}
      </div>
    );
  }
}
